/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card, Row, Col, Image } from 'react-bootstrap';
import * as S from './styles';
import { AppCardTitleImageStyle } from './styles';

export interface IAppCardList {
  name: string;
  value: string;
}

export interface IAppCardProps {
  appCardId: string;
  appCardImage?: string;
  appCardTitle?: string;
  appCardDescription?: string;
  appCardList?: IAppCardList[];
  onAppCardClick?(): void;
  hoverColor: string;
  selected?: boolean;
  selectedColor?: string;
  checkMarkColor?: string;
  checkMarkSymbol?: string;
  borderRadius?: string;
}
const getFirstLetterOfEachWord = (text: string) =>
  text?.match(/\b\w/g)?.join('');

export const AppCard = ({
  appCardId,
  appCardTitle,
  appCardImage,
  appCardDescription,
  appCardList,
  hoverColor,
  selected,
  checkMarkColor,
  checkMarkSymbol,
  borderRadius,
  onAppCardClick,
}: IAppCardProps) => {
  const _renderImageIf = () => {
    if (appCardImage) {
      return (
        <Image
          src={appCardImage}
          className="rounded-1"
          width={80}
          height={80}
          style={{ objectFit: 'contain' }}
        />
      );
    }
    if (appCardTitle) {
      return (
        <div
          className="avatar d-flex align-items-center justify-content-center fw-bold rounded bg-secondary"
          style={S.AppCardTitleImageStyle}
        >
          <span>{getFirstLetterOfEachWord(appCardTitle)}</span>
        </div>
      );
    }
    return null;
  };
  let _isSelected = selected ? 'selected' : '';
  return (
    <S.AppCard
      border="0"
      onClick={onAppCardClick?.bind(null, appCardId)}
      // hoverColor={hoverColor}
      className={_isSelected}
      selectedColor={hoverColor}
      checkMarkColor={checkMarkColor}
      borderRadius={borderRadius}
    >
      <Card.Body>
        <Row>
          <Col xs={4}>{_renderImageIf()}</Col>
          <Col xs={8}>
            {appCardTitle && (
              <h5 className="mb-0 mt-0" style={S.HeadingStyle}>
                {appCardTitle}
              </h5>
            )}
            {appCardDescription && (
              <S.DescriptionStyle>{appCardDescription}</S.DescriptionStyle>
            )}
            <div
              className="p-2 mt-2 d-flex justify-content-between rounded"
              style={S.SectionContainer}
            >
              {appCardList?.map((list, index) => (
                <div
                  key={`app-card-kv-${index}`}
                  className="d-flex flex-column"
                >
                  <span style={S.SectionNameStyle}>{list?.name}</span>
                  <span className="fw-bold">{list?.value}</span>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Card.Body>
      <div className="check">
        <span className="checkmark">{checkMarkSymbol}</span>
      </div>
    </S.AppCard>
  );
};

AppCard.defaultProps = {
  isSelected: false,
  selectedColor: '#44aadd',
  checkMarkColor: '#ffffff',
  checkMarkSymbol: '✔',
  borderRadius: '10px',
};
